<template>
  <div class="crud_form_wrapper">
    <!-- Start:: Title -->
    <div class="form_title_wrapper">
      <h4>{{ $t("SIDENAV.OffersManagement.ShowOffer") }}</h4>
    </div>
    <div class="col-12 text-end">
      <v-btn @click="$router.go(-1)" style="color: #266db0">
        <i class="fas fa-backward"></i>
      </v-btn>
    </div>
    <!-- End:: Title -->

    <!-- Start:: Single Step Form Content -->
    <div class="single_step_form_content_wrapper">
      <form>
        <div class="row">
          <!-- Start:: Image Upload Input -->
          <div class="preview-container text-center my-3">
            <img
              :src="data.file_path"
              alt="Offer Image"
              v-if="data.file_path"
              class="mb-4"
            />
          </div>
          <!-- End:: Image Upload Input -->

          <!-- Start:: Name Arabic Input -->
          <base-input
            col="6"
            type="text"
            :placeholder="$t('SIDENAV.OffersManagement.offerNameAr')"
            v-model.trim="data.name_ar"
            disabled
          />
          <!-- End:: Name Arabic Input -->

          <!-- Start:: Name English Input -->
          <base-input
            col="6"
            type="text"
            :placeholder="$t('SIDENAV.OffersManagement.offerNameEn')"
            v-model.trim="data.name_en"
            disabled
          />
          <!-- End:: Name English Input -->

          <!-- Start:: Service Provider Input -->
          <base-select-input
            col="6"
            :optionsList="[{id: data.user.id, name: data.user.name}]"
            :placeholder="$t('SIDENAV.OffersManagement.serviceProvider')"
            v-model="data.user"
            disabled
          />
          <!-- End:: Service Provider Input -->

          <!-- Start:: Category Input -->
          <base-select-input
            col="6"
            :optionsList="[{id: data.category.id, name: data.category.name}]"
            :placeholder="$t('SIDENAV.OffersManagement.productCategory')"
            v-model="data.category"
            disabled
          />
          <!-- End:: Category Input -->

          <!-- Start:: Product Input -->
          <base-select-input
            col="6"
            :optionsList="[{id: data.product.id, name: data.product.name}]"
            :placeholder="$t('SIDENAV.OffersManagement.productName')"
            v-model="data.product"
            disabled
          />
          <!-- End:: Product Input -->

          <!-- Start:: Discount Input -->
          <base-input
            col="6"
            type="number"
            :placeholder="$t('SIDENAV.OffersManagement.discountPercentage')"
            v-model.trim="data.discount_percentage"
            disabled
          />
          <!-- End:: Discount Input -->

          <!-- Start:: Start Date Input -->
          <base-picker-input
            col="6"
            type="date"
            :placeholder="$t('SIDENAV.OffersManagement.startDate')"
            v-model.trim="data.start_date"
            disabled
          />
          <!-- End:: Start Date Input -->

          <!-- Start:: End Date Input -->
          <base-picker-input
            col="6"
            type="date"
            :placeholder="$t('SIDENAV.OffersManagement.endDate')"
            v-model.trim="data.end_date"
            disabled
          />
          <!-- End:: End Date Input -->

          <!-- Start:: Sizes Table -->
          <div class="col-12 mt-5">
            <h5 style="color: #266db0;">{{ $t('SIDENAV.OffersManagement.offerDetails') }}</h5>
            <div v-for="(size, index) in data.sizes" :key="size.id" class="row mb-2">
              <base-input
                col="4"
                type="text"
                :placeholder="$t('PLACEHOLDERS.size') + ' #' + (index + 1)"
                :value="size.name"
                disabled
              />
              <base-input
                col="4"
                type="text"
                :placeholder="$t('PLACEHOLDERS.price_before_discount') + ' #' + (index + 1)"
                :value="size.price"
                disabled
              />
              <base-input
                col="4"
                type="text"
                :placeholder="$t('PLACEHOLDERS.price_after_discount') + ' #' + (index + 1)"
                :value="size.price_after_discount"
                disabled
              />
            </div>
          </div>
          <!-- End:: Sizes Table -->

          <!-- Start:: Status Switch -->
          <div class="input_wrapper switch_wrapper my-5">
            <v-switch
              color="green"
              :label="data.is_active ? $t('PLACEHOLDERS.active') : $t('PLACEHOLDERS.notActive')"
              v-model="data.is_active"
              hide-details
              disabled
            ></v-switch>
          </div>
          <!-- End:: Status Switch -->
        </div>
      </form>
    </div>
  </div>
</template>

<script>
export default {
  name: "ShowOffer",

  data() {
    return {
      data: {
        file_path: null,
        name_ar: null,
        name_en: null,
        category: {
          id: null,
          name: null
        },
        product: {
          id: null,
          name: null
        },
        user: {
          id: null,
          name: null
        },
        discount_percentage: null,
        start_date: null,
        end_date: null,
        sizes: [],
        is_active: false
      }
    };
  },

  methods: {
    async getOfferData() {
      try {
        const res = await this.$axios({
          method: "GET",
          url: `offers/${this.$route.params.id}`,
        });
        const offer = res.data.data.Offer;
        this.data = {
          file_path: offer.file_path,
          name_ar: offer.name_ar,
          name_en: offer.name_en,
          category: offer.category,
          product: offer.product,
          user: offer.user,
          discount_percentage: offer.discount_percentage,
          start_date: offer.start_date,
          end_date: offer.end_date,
          sizes: offer.sizes,
          is_active: offer.is_active
        };
      } catch (error) {
        this.$message.error(error.response?.data?.message);
      }
    }
  },

  created() {
    this.getOfferData();
  }
};
</script>

<style>
.preview-container img,
.preview-container video {
  max-width: 100%;
  max-height: 200px;
  border: 1px solid #ccc;
  border-radius: 20px;
}
</style>